import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';

import { RootMap, LinkButton, LinkListItem } from '../components';
import { FarmsProvider } from '../providers';
import {
  List,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Snackbar,
  CircularProgress,
  Divider
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/AddCircle';
import SidePanel from './SidePanel';

interface State {
  newFarmDialog: boolean;
  newFarmName: string | null;
}

type Props = WithStyles & RouteComponentProps<any>;

const styles: StyleRulesCallback = theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    height: '100vh'
  },
  list: {
    backgroundColor: theme.palette.grey['100'],
    marginBottom: theme.spacing.unit * 2
  },
  map: {
    flex: 1
  }
});

class RootExplore extends React.Component<Props, State> {
  state = {
    newFarmDialog: false,
    newFarmName: null
  };

  renderBlankSlateDialog(farms: Farm[], loading: boolean) {
    if (loading || !farms) {
      return null;
    }

    return (
      <Dialog open={!farms.length}>
        <DialogTitle>No hay campos en su perfil</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Para comenzar a utilizar Pirwa, lo primero que debemos hacer es dar
            de alta su campo. Si usted ya tiene un usuario, ingrese en su cuenta
            para acceder a sus campos ya cargados.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LinkButton color="primary" to={`/newfarm`}>
            Crear mi primer campo
          </LinkButton>
        </DialogActions>
      </Dialog>
    );
  }

  renderFarms(farms: Farm[]) {
    return farms.map((farm, index) => (
      <>
        <Divider />
        <LinkListItem button={true} key={index} to={`/farms/${farm.id}`}>
          <ListItemText
            primary={farm.name}
            secondary={`${farm.fieldCount} lotes`}
          />
        </LinkListItem>
      </>
    ));
  }

  renderOptionsPanel(farms: Farm[]) {
    const { classes } = this.props;
    return (
      <List component="nav" className={classes.list}>
        <LinkListItem to="/newfarm">
          <ListItemIcon>
            <AddIcon />
          </ListItemIcon>
          <ListItemText primary="Agregar Campo" />
        </LinkListItem>
        {this.renderFarms(farms)}
      </List>
    );
  }

  renderLoading() {
    return (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={true}
        message={
          <>
            <CircularProgress color="secondary" size={25} />
            <span>Cargando campos</span>
          </>
        }
      />
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <FarmsProvider>
        {(farms, loading) => (
          <main className={classes.root}>
            {loading && this.renderLoading()}
            {this.renderBlankSlateDialog(farms, loading)}
            <SidePanel>{this.renderOptionsPanel(farms)}</SidePanel>
            <RootMap
              className={classes.map}
              farms={farms}
              onFarmClick={(f: Farm) =>
                this.props.history.push(`/farms/${f.id}`)
              }
            />
          </main>
        )}
      </FarmsProvider>
    );
  }
}

export default withStyles(styles)(withRouter(RootExplore));



// WEBPACK FOOTER //
// ./src/containers/RootExplore.tsx